import { render, staticRenderFns } from "./FrontRegistered.vue?vue&type=template&id=01648d41&scoped=true"
import script from "./FrontRegistered.vue?vue&type=script&lang=ts"
export * from "./FrontRegistered.vue?vue&type=script&lang=ts"
import style0 from "./FrontRegistered.vue?vue&type=style&index=0&id=01648d41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01648d41",
  null
  
)

export default component.exports